function SubLineComponent($q, $http, AppConstants) {
	'ngInject';

	const service = {
		'fetchSubLines': fetchSubLines,
		'searchSubLines': searchSubLines,
		'fetchSubLine': fetchSubLine,
		'getGoingSubLines': getGoingSubLines,
		'getReturnSubLines': getReturnSubLines,
		'getSubLine': getSubLine,
		'getSubLines': getSubLines,
		'failedRequest': failedRequest,
		'clearGoingSubLines': clearGoingSubLines,
		'clearReturnSubLines': clearReturnSubLines,
		'getPaginationInfo': getPaginationInfo,
		'getGoingPaginationInfo': getGoingPaginationInfo,
		'getReturnPaginationInfo': getReturnPaginationInfo
	};

	const paginationInfo = {};
	let subLines = [];
	let goingPaginationInfo = {};
	let returnPaginationInfo = {};
	let goingSubLines = [];
	let returnSubLines = [];
	let subLine = {};

	return service;

	function fetchSubLines(searchParams, page = 1, promotionId = 0) {
		searchParams.page = page;
		searchParams.per_page = AppConstants.perPage;
		searchParams.with = 'line,line.translation';

		if (promotionId) {
			searchParams.without_promotion = promotionId;
		}

		return $http.get(`${AppConstants.apiUrl}/sub-lines`, {
			'params': searchParams
		})
			.then(setSubLines)
			.catch(failedRequest);
	}

	function searchSubLines(searchParams, direction, page = 1, promotionId = 0) {
		searchParams.page = page;
		searchParams.per_page = 1000;
		searchParams.is_public = searchParams.is_public ? 1 : 0;

		if (promotionId) {
			searchParams.without_promotion = promotionId;
		}

		return $http.get(`${AppConstants.apiUrl}/sub-lines/search`, {
			'params': searchParams
		})
			.then(function(res) {
				if (direction === 'return') {
					return setReturnSubLines(res);
				} else {
					return setGoingSubLines(res);
				}
			})
			.catch(failedRequest);
	}

	function fetchSubLine(subLineId, busId, date, isPublic) {
		const getParams = {
			'date': date,
			'bus_id': busId,
			'is_public': isPublic ? 1 : 0
		};

		return $http.get(`${AppConstants.apiUrl}/sub-lines/${subLineId}`, {
			'params': getParams
		})
			.then(setSubLine)
			.catch(failedRequest);
	}

	function setGoingSubLines(response) {
		goingPaginationInfo.page_size = AppConstants.perPage;
		goingPaginationInfo.page = response.data.current_page;
		goingPaginationInfo.total = response.data.total;
		goingPaginationInfo.type = response.data.type;
		goingSubLines = response.data.data;

		return goingSubLines;
	}

	function setReturnSubLines(response) {
		returnPaginationInfo.page_size = AppConstants.perPage;
		returnPaginationInfo.page = response.data.current_page;
		returnPaginationInfo.total = response.data.total;
		returnPaginationInfo.type = response.data.type;
		returnSubLines = response.data.data;

		return returnSubLines;
	}

	function setSubLines(response) {
		paginationInfo.page_size = AppConstants.perPage;
		paginationInfo.page = response.data.current_page;
		paginationInfo.total = response.data.total;
		subLines = response.data.data;

		return subLines;
	}

	function setSubLine(response) {
		subLine = response.data.data;

		return subLine;
	}

	function getGoingSubLines() {
		return goingSubLines;
	}

	function getReturnSubLines() {
		return returnSubLines;
	}

	function getSubLines() {
		return subLines;
	}

	function getSubLine() {
		return subLine;
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function getGoingPaginationInfo() {
		return goingPaginationInfo;
	}

	function getReturnPaginationInfo() {
		return returnPaginationInfo;
	}

	function clearGoingSubLines() {
		goingSubLines = [];
		goingPaginationInfo = {};
	}

	function clearReturnSubLines() {
		returnSubLines = [];
		returnPaginationInfo = {};
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}
}
export default SubLineComponent;



/** WEBPACK FOOTER **
 ** ./client/components/sub-line/sub-line.service.js
 **/